<template>
  <div v-if="file.path">
    <v-btn icon @click="download">
      <v-icon>mdi-file-download</v-icon>
    </v-btn>
    <v-btn @click="deleteDocument" icon v-if="deleteDocs">
      <v-icon>mdi-delete-circle-outline</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    file: { required: true },
    deleteDocs: { required: false, type: Boolean, default: true },
  },
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    urlPath() {
      return `/api/v1/documents/${this.file.id}`;
    },
  },
  methods: {
    download() {
      this.processing = true;
      this.$http
        .get(this.urlPath, { responseType: "blob" })
        .then((response) => this.convertResponse(response))
        .catch(() => Notify.error("Something went wrong"))
        .finally(() => {
          this.processing = false;
        });
    },
    deleteDocument() {
      Notify.confirm("This will delete the document").then(() => {
        this.$http
          .delete(this.urlPath)
          .then(() => {
            this.$emit("destroyed", this.file);
            Notify.success("File was deleted successfully");
          })
          .catch(() => this.$snotify.error("Something went wrong"));
      });
    },

    convertResponse(response) {
      const blob = new Blob([response], { type: response.type });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.file.path);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  },
};
</script>
